import {project2BaseUrl } from './remoteClient';

export async function getJobsRequest(token, params){
    
        return await project2BaseUrl.get(`/jobPost/getJobPostingsWithMatch?${params.toString()}`,{
            headers: {
                "Authorization": 'Bearer ' + token
            }
        })
    }

export async function addJobRequest(token, jobData){
         return await project2BaseUrl.post('/jobPost/addJob',jobData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
}

export async function updateJobRequest(token, jobData){

        return await project2BaseUrl.post('/jobPost/editJob',jobData, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
}

export async function jobSkillRequest(token, jobPostingId){
        return await project2BaseUrl.get(`/jobPost/getJobPostingSkills?jobPostingId=${jobPostingId}`,{
            headers: {
                Authorization: `Bearer ${token}`
        }});
}

